"use client";

import React from "react";
import { Instagram, Tag, ArrowRight, CircleAlert } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function DealsAndSpecialsShowcase() {
  const dealsData = [{
    title: "THE SMASH COMBO",
    price: "$14.99",
    badge: "BEST SELLER",
    description: "The ultimate Punjabi-American fusion experience.",
    items: "Double Smash Burger, Masala Fries, and Fountain Drink",
    fine_print: "Available daily until 10 PM",
    footer: <Button className="w-full rounded-none h-14 text-base tracking-widest font-serif bg-primary hover:bg-primary/90 text-primary-foreground">ORDER COMBO</Button>
  }, {
    title: "FAMILY FEAST",
    price: "$45.99",
    badge: "VALUE PACK",
    description: "Feed the whole tribe with our signature selection.",
    items: "4 Burgers, 2 Large Fries, 10pc Wings, and 4 Drinks",
    fine_print: "Perfect for 4-5 people",
    footer: <Button className="w-full rounded-none h-14 text-base tracking-widest font-serif bg-primary hover:bg-primary/90 text-primary-foreground">ORDER FEAST</Button>
  }, {
    title: "JUMMA SPECIALS",
    price: "VARIES",
    badge: "FRIDAY ONLY",
    description: "Traditional flavors to celebrate the blessed day.",
    items: "Special Karahi, Biryani, and Traditional Desserts",
    fine_print: "Available every Friday after 2 PM",
    footer: <Button className="w-full rounded-none h-14 text-base tracking-widest font-serif bg-primary hover:bg-primary/90 text-primary-foreground">VIEW SPECIALS</Button>
  }, {
    title: "LATE NIGHT CRAVE",
    price: "$9.99",
    badge: "NIGHT OWL",
    description: "Satisfy those midnight hunger pangs.",
    items: "Any Single Burger + Small Fries",
    fine_print: "Valid 10 PM - Close",
    footer: <Button className="w-full rounded-none h-14 text-base tracking-widest font-serif bg-primary hover:bg-primary/90 text-primary-foreground">GRAB DEAL</Button>
  }];
  const placeholders = [{
    id: 1,
    src: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/SULTANIGCHICKNEN.png?v=or6904ghawr",
    srcset: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/SULTANICHIEKN-1.png?v=r5ebj3tc2e-wvc-srcset",
    sizes: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/SULTANICHIEKN-1.png?v=of51gpssj1f-wvc-sizes",
    alt: "The Smash Combo Deal"
  }, {
    id: 2,
    src: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/buffyyy.png?v=u5m6tc1mqo",
    srcset: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/BUFFETTTT.png?v=v3hgy1zule-wvc-srcset",
    sizes: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/BUFFETTTT.png?v=gcpb1rvgmt-wvc-sizes",
    alt: "Family Feast Value Pack"
  }, {
    id: 3,
    src: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/JUMMIE.png?v=78mcsd4whqq",
    srcset: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/JUMMIE.png?v=frmrng56xhm-wvc-srcset",
    sizes: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/JUMMIE.png?v=c4iin8jwro-wvc-sizes",
    alt: "Jumma Specials Friday Deal"
  }, {
    id: 4,
    src: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/LUNCHIE.png?v=vmc9yjuvlpr",
    srcset: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/LUNCHIE.png?v=484v142rbwt-wvc-srcset",
    sizes: "https://logical-turkey.10web.cloud/wp-content/uploads/2026/04/LUNCHIE.png?v=z6jv44utdc-wvc-sizes",
    alt: "Late Night Crave Deal"
  }];
  return <section id="dealsandspecialsshowcase" className="bg-background py-16 md:py-24 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl text-foreground uppercase tracking-wider mb-4">
            DEALS & <span className="text-primary">SPECIALS</span>
          </h2>
          <p className="font-sans text-muted-foreground max-w-2xl mx-auto text-lg">
            Exclusive offers and limited-time combos. Grab them before they're gone.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-12 max-w-4xl mx-auto">
          {placeholders.map((item, i) => <div key={item.id} data-index={i} className="aspect-square w-full overflow-hidden rounded-lg border border-border/50 bg-muted transition-all duration-500 hover:scale-[1.02] group relative">
              <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" loading="lazy" />
              <div className="absolute inset-0 bg-linear-to-t from-background/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>)}
        </div>

        <div className="mt-16 md:mt-24">
          <Separator className="bg-border/50 mb-8" />
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 bg-card/50 border border-border/50 rounded-2xl p-6 md:p-8">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Instagram className="w-6 h-6 text-primary" />
              </div>
              <div>
                <h3 className="font-serif text-xl tracking-wide text-foreground m-0">
                  Follow for Secret Drops
                </h3>
                <Link className="text-muted-foreground hover:text-primary transition-colors font-sans text-sm flex items-center gap-1" to="https://instagram.com/sultanigrill" newTab>
                  @sultanigrill <ArrowRight className="w-3 h-3" />
                </Link>
              </div>
            </div>
            <div className="text-center md:text-right">
              <Badge variant="outline" className="border-primary/30 text-primary font-serif tracking-wider px-4 py-1.5 text-sm bg-primary/5">
                MORE DEALS COMING SOON
              </Badge>
            </div>
          </div>
        </div>
      </div>
    </section>;
}